<!-- Backdrop (mobile only, closes sidebar on tap outside) -->

@if (sidebarOpen()) {
  <button
    type="button"
    aria-label="Close menu"
    class="fixed inset-0 z-40 md:hidden"
    (click)="closeSidebar()"
  ></button>
}

<section class="flex bg-neutral-canvas min-h-screen overflow-x-hidden md:overflow-x-visible">
  @if (showFeatureUpdateFeedback()) {
    <app-feature-update-feedback
      [countryId]="featureUpdateCountryId()"
      (closed)="onFeatureUpdateFeedbackClosed()"
    ></app-feature-update-feedback>
  }

  <!-- Sidebar: fixed overlay on mobile, static column on desktop -->
  <aside
    id="mobile-sidebar"
    class="fixed inset-x-0 bottom-0 top-18 z-50 md:sticky md:top-0 md:h-screen md:block md:inset-auto md:self-start md:flex-shrink-0 md:overflow-hidden md:transition-[width] md:duration-300"
    [class.hidden]="!sidebarOpen()"
    [class.md:w-18]="isDesktopSidebarCollapsed()"
    [class.md:w-73]="!isDesktopSidebarCollapsed()"
    [attr.aria-hidden]="isMobileView() && !sidebarOpen() ? true : null"
  >
    <app-sidebar
      class="h-full overflow-hidden"
      [isCollapsed]="isDesktopSidebarCollapsed()"
      [isDashboardPage]="isDashboardPage()"
      (toggleCollapse)="toggleDesktopSidebar()"
      (closeSidebar)="closeSidebar()"
    ></app-sidebar>
  </aside>

  <!-- Main content column -->
  <div class="flex min-w-0 flex-1 flex-col shadow-header">
    <!-- Mobile header (hamburger + logo): fixed so only the page scrolls beneath it -->
    <header
      class="fixed top-0 inset-x-0 z-30 md:hidden flex items-center justify-between px-4 py-3 bg-brand-navBar border-b border-white/10 shadow-header"
    >
      <a
        routerLink="/"
        class="border-none bg-transparent p-0 cursor-pointer inline-flex text-inherit no-underline"
        aria-label="Go to home"
      >
        <img
          [src]="'/assets/images/CNH_capitals.png'"
          [alt]="ALT_TEXT.CNH_LOGO"
          class="h-8 w-36 object-contain object-left"
          loading="lazy"
        />
      </a>
      <div class="flex items-center gap-6">
        <div class="relative">
          <button
            type="button"
            class="relative w-10 h-10 border-none bg-transparent cursor-pointer"
            [attr.aria-label]="
              notificationCount() > 0
                ? 'Notifications, ' + notificationCount() + ' unread'
                : 'Notifications'
            "
            aria-haspopup="true"
            [attr.aria-expanded]="isMobileNotificationDropdownOpen()"
            (click)="toggleMobileNotificationDropdown()"
          >
            <img
              [src]="IMAGE_PATHS.NOTIFICATION"
              [alt]="ALT_TEXT.NOTIFICATION_ICON"
              loading="lazy"
              class="brightness-0 invert"
            />
            @if (notificationCount() > 0) {
              <span
                class="absolute top-1 right-1 min-w-5 h-5 px-1 bg-secondary-mustard text-xs rounded-full text-white text-center flex justify-center items-center"
                >{{ notificationCount() }}</span
              >
            }
          </button>

          @if (isMobileNotificationDropdownOpen()) {
            <app-notification-dropdown
              panelClass="fixed left-2 right-2 top-16 z-50"
              contentClass="px-4 py-4"
              listClass="max-h-80 gap-5"
              itemGapClass="gap-3"
              messageClass="leading-7"
              emptyStateClass="min-h-32 px-4"
              footerClass="mt-5 gap-4 text-sm"
              (panelClose)="closeMobileNotificationDropdown()"
              (viewAll)="navigateToNotifications()"
              (notificationsCleared)="onMobileNotificationsCleared()"
            ></app-notification-dropdown>
          }
        </div>
        <button
          type="button"
          (click)="toggleSidebar()"
          class="w-10 h-10 bg-white rounded-full flex items-center justify-center border-none"
          [attr.aria-label]="sidebarOpen() ? 'Close menu' : 'Open menu'"
          aria-controls="mobile-sidebar"
          [attr.aria-expanded]="sidebarOpen()"
        >
          <img
            [src]="sidebarOpen() ? IMAGE_PATHS.CLOSE_SIDEBAR : IMAGE_PATHS.MENU"
            [alt]="sidebarOpen() ? ALT_TEXT.CLOSE : ALT_TEXT.MENU"
            loading="lazy"
            class="brightness-0"
          />
        </button>
      </div>
    </header>

    <!-- Desktop header (overflow-visible so account dropdown is not clipped) -->
    <div class="sticky top-0 z-30 hidden overflow-visible md:block">
      <app-header [isDashboardPage]="isDashboardPage()"></app-header>
    </div>

    <main class="min-h-0 flex-1 overflow-x-auto p-4 mt-18 md:mt-0 md:p-6">
      <router-outlet></router-outlet>
    </main>
  </div>
</section>
